import React from 'react'
import { useNavigate } from 'react-router-dom'

const AdminTabs = ({ activeTab, setActiveTab }) => {
  const navigate = useNavigate()

  const tabs = [
    { id: 'dashboard', label: 'لوحة التحكم', icon: '📊' },
    { id: 'products', label: 'المنتجات', icon: '📦' },
    { id: 'categories', label: 'الفئات', icon: '📁' },
    { id: 'orders', label: 'الطلبات', icon: '📋' },
    { id: 'users', label: 'المستخدمين', icon: '👥' }
  ]

  const allTabs = [
    { id: 'dashboard', label: 'لوحة التحكم', icon: '📊' },
    { id: 'products', label: 'المنتجات', icon: '📦' },
    { id: 'categories', label: 'الفئات', icon: '📁' },
    { id: 'orders', label: 'الطلبات', icon: '📋' },
    { id: 'users', label: 'المستخدمين', icon: '👥' },
    { id: 'settings', label: 'الإعدادات', icon: '⚙️' },
    { id: 'slider', label: 'الشرائح', icon: '🖼️' },
    { id: 'cities', label: 'المدن', icon: '🏙️' },
    { id: 'promo-codes', label: 'أكواد الخصم', icon: '🎟️' },
    { id: 'google-merchant', label: 'Google Merchant', icon: '🛍️' },
    { id: 'product-themes', label: 'تصدير صور المنتجات', icon: '🎨', isLink: '/admin/product-themes' }
  ]

  return (
    <>
      {/* Desktop Sidebar - Part of page flow */}
      <div className="hidden md:block w-80 bg-white shadow-xl border-l-2 border-primary-200 h-full overflow-y-auto">
        <div className="p-6">
          <h2 className="text-xl font-bold text-primary-800 mb-6 text-center">لوحة الإدارة</h2>
          <nav className="space-y-3">
            {allTabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => tab.isLink ? navigate(tab.isLink) : setActiveTab(tab.id)}
                className={`w-full flex items-center space-x-4 px-4 py-3 rounded-lg font-medium text-sm ${
                  tab.isLink
                    ? 'bg-slate-50 text-primary-800 border-2 border-primary-200 hover:border-[#8B0000] hover:text-[#8B0000]'
                    : activeTab === tab.id
                    ? 'bg-primary-600 text-white shadow-md'
                    : 'bg-slate-50 text-primary-800 border-2 border-primary-200'
                }`}
              >
                <span className="text-lg">{tab.icon}</span>
                <span className="flex-1 text-right">{tab.label}</span>
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Mobile Bottom Navigation - Visible only on mobile */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
        {/* First row - Most used tabs (4 items) */}
        <div className="flex items-center px-2 py-2 border-b border-gray-100 bg-gray-50 w-screen">
          {allTabs.slice(0, 4).map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex flex-col items-center justify-center p-2 rounded-lg transition-all flex-1 mx-1 ${
                activeTab === tab.id
                  ? "bg-blue-500 text-white shadow-md scale-105"
                  : "bg-white text-gray-600 hover:bg-gray-100 border border-gray-200"
              }`}
              style={{ minHeight: '60px', minWidth: '70px', maxWidth: '90px' }}
            >
              <span className="text-base mb-1">{tab.icon}</span>
              <span className="text-xs font-medium text-center leading-tight truncate w-full">{tab.label}</span>
            </button>
          ))}
        </div>
        
        {/* Second row - Additional tabs (6 items) */}
        <div className="flex items-center px-2 py-2 bg-gray-50 w-screen">
          {allTabs.slice(4).map((tab) => (
            <button
              key={tab.id}
              onClick={() => tab.isLink ? navigate(tab.isLink) : setActiveTab(tab.id)}
              className={`flex flex-col items-center justify-center p-2 rounded-lg transition-all flex-1 mx-1 ${
                activeTab === tab.id
                  ? "bg-blue-500 text-white shadow-md scale-105"
                  : "bg-white text-gray-600 hover:bg-gray-100 border border-gray-200"
              }`}
              style={{ minHeight: '60px', minWidth: '55px', maxWidth: '70px' }}
            >
              <span className="text-base mb-1">{tab.icon}</span>
              <span className="text-xs font-medium text-center leading-tight truncate w-full">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>
    </>
  )
}

export default AdminTabs
